import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    closeOnBackdrop: { type: Boolean, default: true },
    closeOnEscape: { type: Boolean, default: true },
    autoOpen: { type: Boolean, default: false },
    dialogId: { type: String, default: "" },
  };

  connect() {
    this.handleClose = this.handleClose.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.closeBeforeRender = () => {
      if (this.element.open) {
        this.element.close();
        document.body.style.overflow = "";
      }
    };
    this.clearFrameBeforeCache = () => {
      const frame = this.element.closest("turbo-frame");
      if (frame) {
        frame.innerHTML = "";
      }
    };

    this.element.addEventListener("close", this.handleClose);
    this.element.addEventListener("cancel", this.handleCancel);
    this.element.addEventListener("click", this.handleBackdropClick);
    document.addEventListener("turbo:before-render", this.closeBeforeRender);
    document.addEventListener("turbo:before-cache", this.clearFrameBeforeCache);

    if (this.autoOpenValue) {
      requestAnimationFrame(() => this.open());
    }
  }

  disconnect() {
    if (this.element.open) {
      this.element.close();
      document.body.style.overflow = "";
    }
    this.element.removeEventListener("close", this.handleClose);
    this.element.removeEventListener("cancel", this.handleCancel);
    this.element.removeEventListener("click", this.handleBackdropClick);
    document.removeEventListener("turbo:before-render", this.closeBeforeRender);
    document.removeEventListener("turbo:before-cache", this.clearFrameBeforeCache);
  }

  handleCancel(event) {
    document.body.style.overflow = "";
  }

  open(event) {
    event?.preventDefault();
    const modal = this.dialogIdValue ? document.getElementById(this.dialogIdValue) : this.element;
    if (modal) {
      modal.showModal();
      document.body.style.overflow = "hidden";
    }
  }

  close(event) {
    event?.preventDefault();
    const modal = this.dialogIdValue ? document.getElementById(this.dialogIdValue) : this.element;
    if (modal) {
      modal.close();
      document.body.style.overflow = "";
    }
  }

  handleClose() {
    document.body.style.overflow = "";
  }

  handleBackdropClick(event) {
    if (!this.closeOnBackdropValue) return;

    const rect = this.element.getBoundingClientRect();
    const isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;

    if (!isInDialog && this.element.open) {
      this.close(event);
    }
  }
}
